import Vue from 'vue'

export const TabEventBus = new Vue()
